import _ from 'lodash';
import React, { useContext, useEffect, useMemo, useReducer, useState } from 'react';
import { sidebarHandlers, sidebarInitialState, sidebarMenuTypes, sidebarReducer, sidebarSliderTypes } from '../../../../global/cnr/reducers/SidebarReducer';
import { ScheduleCalendar } from '../../../../global/components/calendar/Calendar';
import { gEnums } from '../../../../global/enums/globalEnums';
import { SportsSeasonContext } from '../../cnr/contexts/SportsSeasonContext';
import { createScheduleTypes } from '../../cnr/reducers/CreateSportsReducer';
import { CreatePlayoffContext } from '../CreatePlayoff';
import { CreateSportsContext } from '../CreateSports';
import { CreateSportsSeasonContext } from '../CreateSeason';
import { useCreateSportsSeason } from 'projectSpecific/sports/useHelpers/useCreateSeasonal';
import { useSportsFilters } from 'projectSpecific/sports/useHelpers/useSportsFilters';
import { Button, Icon, Label } from 'semantic-ui-react';
import Wrapper, { wrapperTypes } from 'global/wrappers/Wrapper';
import WrapperVertCols from 'global/wrappers/WrapperVertCols';
import ItemMenuSquares, { _imsTypes } from 'global/wrappers/ItemMenuSquares';

const sidebarType = 'createScheduleDates'

const CreateSectionDates = (props) => {

  const _asat = gEnums.availableSubActionTypes

  const { createScheduleType, menuDisplayType, noMid } = props ?? {}

  // sportsSeasonContext
  const sportsSeasonContext = useContext(SportsSeasonContext)
  const { sportsSeason_handlers } = sportsSeasonContext ?? {}

  // createSportsContext
  const createSportsContext = useContext(CreateSportsContext);
  const { createSports_state } = createSportsContext ?? {}
  const { subActionType, levels_info } = createSports_state ?? {}

  // createSportsSeasonContext
  const createSportsSeasonContext = useContext(CreateSportsSeasonContext);
  const { createSportsSeason_state, createSportsSeason_handlers } = createSportsSeasonContext ?? {}
  const { getScheduleDatesInfo } = useCreateSportsSeason()
  const { sportsSeason_selected } = createSportsSeason_state
  const { seasonals, matches } = sportsSeason_selected ?? {}
  const { teams, sectionDates: sectionDates_season, crossSectionDates, sectionTeamCounts } = seasonals ?? {}

  console.log('seasonals', seasonals)

  // createPlayoffContexts
  const createPlayoffContext = useContext(CreatePlayoffContext);
  const { createPlayoff_state, createPlayoff_handlers } = createPlayoffContext ?? {}
  const { playoff_info, playoffGroupKey } = createPlayoff_state ?? {}
  const { playoffLevelTeams, playoffDates_current, playoffLevel } = playoff_info ?? {}
  const { currentDates: currentDates_playoffs } = playoffDates_current ?? {}

  const { getSectionDates } = useSportsFilters({ teams })

  const _sectionDates = useMemo(() => {
    if (!_.isEmpty(matches)) {
      const { sectionDates: sds } = getSectionDates({ matches })
      return sds
    } else {
      return sectionDates_season
    }
  }, [sectionDates_season])


  const _currentDates = createScheduleType === createScheduleTypes.season ? sectionDates_season : currentDates_playoffs

  // sidebar
  const [sidebar_state, sidebar_dispatch] = useReducer(sidebarReducer, sidebarInitialState({ sidebarType, handlers: sportsSeason_handlers }));
  const sidebar_handlers = sidebarHandlers(sidebar_dispatch)
  const { sidebar_items, currents, dimmed } = sidebar_state ?? {}
  const { setInit } = sidebar_handlers ?? {}

  const { ms_dataGroups } = sidebar_items ?? {}
  const { selected: selected_pg } = ms_dataGroups ?? {}
  const { item: item_pg } = selected_pg ?? {}

  const [levels, setLevels] = useState()
  const [selectedSection, setSelectedSection] = useState()
  const [selectedTeamCount, setSelectedTeamCount] = useState()

  const currentDates = _sectionDates?.[selectedSection]

  useEffect(() => {
    let _sidebarSliderType = sidebarSliderTypes.labeled
    if (menuDisplayType && menuDisplayType !== gEnums.menuDisplayTypes.menuButtons) { _sidebarSliderType = sidebarSliderTypes.normal }
    switch (createScheduleType) {
      case createScheduleTypes.season:
        if (sectionTeamCounts) {
          setInit({
            smt: sidebarMenuTypes.one,
            items: _.isEmpty(sectionTeamCounts) ? [6, 7] : sectionTeamCounts,
            currents,
            as: 'dataGroups',
            sidebarSliderType: _sidebarSliderType,
          })
        }
        break;
      default:
      // nothing
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [sectionTeamCounts]);

  // once
  useEffect(() => {

    if (playoffLevelTeams) {
      const _levels = Object.keys(playoffLevelTeams).sort().reverse()
      setLevels(_levels)
    }

    switch (createScheduleType) {
      case createScheduleTypes.season:
        const { existing } = levels_info ?? {}
        const _existing = _.filter(existing, { checked: true })
        break;
      default:
      // nothing
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, []);

  useEffect(() => {
    let _sidebarSliderType = sidebarSliderTypes.labeled
    if (menuDisplayType && menuDisplayType !== gEnums.menuDisplayTypes.menuButtons) { _sidebarSliderType = sidebarSliderTypes.normal }
    switch (createScheduleType) {
      case createScheduleTypes.playoff:
        if (playoffLevel) {
          setInit({
            smt: sidebarMenuTypes.one,
            items: [playoffLevel],
            currents,
            as: 'dataGroups',
            sidebarSliderType: _sidebarSliderType,
          })
        } else if (levels) {
          setInit({
            smt: sidebarMenuTypes.one,
            items: levels,
            currents,
            as: 'dataGroups',
            sidebarSliderType: _sidebarSliderType,
          })
        }
        break;
      default:
      // nothing
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [levels, playoffLevel]);

  // this happens when the level has changed?
  useEffect(() => {
    if (item_pg) {
      switch (createScheduleType) {
        case createScheduleTypes.playoff:
          const _playoffGroup = playoffLevelTeams[item_pg]
          createPlayoff_handlers.handleSet_team_playoffGroup(item_pg, _playoffGroup)
          // createPlayoff_handlers.handleAmmend_playoffDateGroup({ levelKey: item_pg })
          break;
        case createScheduleTypes.season:
          const seasonDateProps = { sectionTeamCount: item_pg, selectedSection }
          createSportsSeason_handlers.handleAmmend_seasonSectionDateGroup(seasonDateProps)
          break;
        default:
        // nothing
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [item_pg]);

  useEffect(() => {
    if (playoffGroupKey) {
      switch (createScheduleType) {
        case createScheduleTypes.playoff:
          createPlayoff_handlers.handleAmmend_playoffDateGroup()
          break;
        default:
        // nothing
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [playoffGroupKey]);

  const fnAlt = (item) => {
    const _sdInfo = getScheduleDatesInfo({
      currentSectionCount: item,
      sectionDates: _currentDates?.[item]
    })

    let iconName = _sdInfo?.currentCount >= _sdInfo?.currentNeeded ? 'check circle outline' : 'circle outline'
    let iconColor = _sdInfo?.currentCount === _sdInfo?.currentNeeded ? 'green' : 'grey'
    if (_sdInfo?.currentCount > _sdInfo?.currentNeeded) { iconColor = 'blue' }

    const icon_check = <Icon style={{ marginLeft: '1em' }} name={iconName} color={iconColor} />
    const icon_crossOvver = <Icon style={{ marginLeft: '1em' }} name={'exchange'} color={iconColor} />
    return <div>{`${_sdInfo?.currentCount} of ${_sdInfo?.currentNeeded}`}{icon_check}{icon_crossOvver}</div>
  }

  const content = () => {

    const hc_tc = (item) => setSelectedTeamCount(item)

    switch (subActionType) {

      case _asat.createPlayoff:
        return <ScheduleCalendar
          subActionType={subActionType}
          createScheduleType={createScheduleType}
          currentDates={currentDates}
          selectedSection={selectedSection} />

      case _asat.createSeason:
        return <WrapperVertCols mvc={'1-4'}>
          {/* sections by count */}
          <Wrapper
            header={'Section Team Counts'}
            content={
              <ItemMenuSquares
                menuItems={sectionTeamCounts}
                imsType={_imsTypes.inline}
                onClick={hc_tc}
                activeItem={selectedTeamCount}
                fn_altContent={fnAlt}
              />
            }
          ></Wrapper>
          {/* Calendar */}
          <Wrapper
            header={'Season Calendar'}
            content={
              <ScheduleCalendar
                subActionType={subActionType}
                createScheduleType={createScheduleType}
                currentDates={sectionDates_season?.[selectedTeamCount] || []}
                crossSectionDates={crossSectionDates?.[selectedTeamCount] || []}
                selectedSection={selectedTeamCount} />
            }
          ></Wrapper>
        </WrapperVertCols>

      default:
        return <div>No Create Type</div>
    }
  }

  const btns_schedule = (btnDates, currentCount, currentNeeded) => {
    const btns = _.map(btnDates, (tc, tck) => (
      <Button className={selectedSection === tck ? 'btn-sel' : null} color={selectedSection === tck ? 'blue' : 'black'} onClick={() => setSelectedSection(tck)}>{tck}</Button>
    ))
    const _ready = currentCount === currentNeeded
    return <div>
      <div>
        <Label color={_ready ? 'green' : 'grey'}>{`${currentCount} of ${currentNeeded}`}</Label>
      </div>
    </div>
  }

  const header = () => {
    switch (subActionType) {
      case _asat.createPlayoff:
        return btns_schedule(playoffDates_current?.currentDates_playoffs, playoffDates_current?.currentCount, playoffDates_current?.currentNeeded)
      case _asat.createSeason:
        return _.startCase('Schedule Dates')
      // return <ScheduleCalendar
      //   subActionType={subActionType}
      //   createScheduleType={createScheduleType}
      //   currentDates={currentDates}
      //   selectedSection={selectedSection} />
      default:
        return <div>No Create Type</div>
    }

  }

  return <Wrapper
    header={header()}
    content={content()}
    wrapperType={wrapperTypes.padded}
    noMid={noMid}
    css={{ container: 'app-dark-mode', header: 'nob' }}
  ></Wrapper >

}

export default CreateSectionDates